import React from "react";
import AskForm from "./AskForm";
import {
  BulletList,
  ContentGrid,
  ForumSection,
  ForumShell,
  HeroActions,
  HeroCard,
  HeroEyebrow,
  HeroText,
  HeroTitle,
  MainColumn,
  Panel,
  PanelTitle,
  SecondaryButton,
  Sidebar,
} from "./ForumStyles";

function AskQuestionPage() {
  return (
    <ForumSection>
      <ForumShell>
        <HeroCard>
          <HeroEyebrow>Ask the Community</HeroEyebrow>
          <HeroTitle>Post a clear engineering question and get reviewed support.</HeroTitle>
          <HeroText>
            Questions are reviewed before they go live, so a little detail helps a lot.
            Mention your technical context, your expected outcome, and any constraints
            you are working with.
          </HeroText>
          <HeroActions>
            <SecondaryButton to="/forum">Back to Forum</SecondaryButton>
          </HeroActions>
        </HeroCard>

        <ContentGrid>
          <MainColumn>
            <AskForm />
          </MainColumn>

          <Sidebar>
            <Panel>
              <PanelTitle>Before you submit</PanelTitle>
              <BulletList>
                <li>Use a descriptive title that summarizes the issue.</li>
                <li>Include process data, equipment context, or training scope where relevant.</li>
                <li>Keep questions professional and directly technical.</li>
              </BulletList>
            </Panel>

            <Panel>
              <PanelTitle>Review process</PanelTitle>
              <BulletList>
                <li>Questions enter the moderation queue first.</li>
                <li>Approved questions appear publicly on the forum.</li>
                <li>You can come back later and share the public link once approved.</li>
              </BulletList>
            </Panel>
          </Sidebar>
        </ContentGrid>
      </ForumShell>
    </ForumSection>
  );
}

export default AskQuestionPage;
